import styled from 'styled-components'
import { COLOR } from '../../themes'

export const FilterSelectStyle = styled.div`
  position: relative;
  flex: 1;
  display: flex;

  .custom-select-trigger {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
  .custom-select-text {
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
    color: ${COLOR.GRAY_27};
    line-height: 1.5;
    padding: 0 0 3px 0;
  }
  .custom-select-text.selected {
    color: ${COLOR.BLACK_6};
  }
  .custom-select-icon {
    width: 24px;
    height: 24px;
  }
  .dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }
  .custom-select-dropdown {
    position: absolute;
    top: 100%;
    left: -13px;
    width: calc(100% + 26px);
    background-color: ${COLOR.WHITE};
    box-shadow: none;
    border-radius: 8px;
    border: 1.5px solid ${COLOR.GRAY_5};
    z-index: 1000;
    padding: 0;
    margin-top: 12px;
    overflow-y: auto;
    max-height: 240px;
  }
  .dropdown-option {
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    cursor: pointer;
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
  }
`
